import React from "react";
import { Link } from "gatsby";

const Technologies = () => (
    <>
      <div className="pageWrapper">
        <main className="mainHolder sevicesMainHolder ">
          <section
            className="siteSection hero-sec for-workpage bg-pattern-6">
            <div className="container">
              <div className="siteSection--body content-body text-center">
                <div className="row">
                  <div className="col text-center">
                    <h1 className="header-title lg cd-headline slide">
                      <span>Think-</span>
                      <span className="cd-words-wrapper">
                        <b className="is-visible highlight">BizDamn</b>
                        <b className="highlight">Data</b>
                        <b className="highlight">Social</b>
                        <b className="highlight">Content</b>
                        <b className="highlight">Big</b>
                        <b className="highlight">Trending</b>
                        <b className="highlight">Agile</b>
                        <b className="highlight">Search</b>
                      </span>
                    </h1>

                  </div>
                </div>
              </div>
            </div>
          </section>


          <section id='web-development' style={{ minHeight: "60rem" }} className="siteSection with-bg b-spaced lab-product hackr-item">
            <div className="bgGradient hackr-blue radial-tl gradient-sec"></div>
            <div className="siteSection--header">
              <div className="siteSection--header">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <Link to="/web-development" className="link-hover">
                        <h2  data-sal="slide-up" className="header-title text-primary">Web Development</h2></Link>
                      {/* <p className="header-description">At BizDamn, we design and develop websites and web apps that can make sure you’re seen and heard in the right circles.</p> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="siteSection--body">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <img src="" className="artwork" />

                      <div className="serviceTechHolder">
                        <div className="serviceTechHolder-header">
                          <div className="title-holder">
                            <h4 data-sal="slide-up"className="title">Backend Development</h4>
                          </div>


                        </div>

                        <div className="serviceTechHolder-body">
                          <ul className="tech-list">

                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/NodeJS.svg" alt="NodeJS" />
                              <p className="tech-title">NodeJS</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Flask.svg" alt="Flask" />
                              <p className="tech-title">Flask</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Django.svg" alt="Django" />
                              <p className="tech-title">Django</p>
                            </li>


                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Laravel.svg" alt="Laravel" />
                              <p className="tech-title">Laravel</p>
                            </li>

                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/PHP.svg" alt="PHP" />
                              <p className="tech-title">PHP</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Python.svg" alt="Python" />
                              <p className="tech-title">Python</p>
                            </li>

                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/AWS.svg" alt="AWS" />
                              <p className="tech-title">AWS</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Redis.svg" alt="Redis" />
                              <p className="tech-title">Redis</p>
                            </li>
                            {/* <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/Elasticsearch.svg" alt="Elasticsearch" />
                            <p className="tech-title">Elasticsearch</p>
                          </li> */}


                          </ul>
                        </div>
                      </div>

                      <div className="serviceTechHolder">
                        <div className="serviceTechHolder-header">
                          <div className="title-holder">
                            <h4 data-sal="slide-up"className="title">Frontend Development</h4>
                          </div>
                        </div>

                        <div className="serviceTechHolder-body">
                          <ul className="tech-list">

                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/React.svg" alt="React" />
                              <p className="tech-title">React</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Gatsby.svg" alt="Gatsby" />
                              <p className="tech-title">Gatsby</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/NextJs.svg" alt="Next.js" />

                              <p className="tech-title">Next.js</p>
                            </li>

                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Jquery.svg" alt="jQuery" />
                              <p className="tech-title">jQuery</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/SASS.svg" alt="SASS" />
                              <p className="tech-title">SASS</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Bootstrap.svg" alt="Bootstrap" />
                              <p className="tech-title">Bootstrap</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Talvind.svg" alt="Talwind" />
                              <p className="tech-title">Talwind</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/HTML5.svg" alt="HTML5" />
                              <p className="tech-title">HTML5</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/CSS3.svg" alt="CSS 3" />
                              <p className="tech-title">CSS 3</p>
                            </li>

                          </ul>
                        </div>

                      </div>



                      <div className="serviceTechHolder">
                        <div className="serviceTechHolder-header">
                          <div className="title-holder">
                            <h4 data-sal="slide-up"className="title">Database</h4>
                          </div>
                        </div>
                        <div className="serviceTechHolder-body">
                          <ul className="tech-list">
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/MySQL.svg" alt="MySQL" />
                              <p className="tech-title">MySQL</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/PostgreSQL.svg" alt="PostgreSQL" />
                              <p className="tech-title">PostgreSQL</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/MongoDB.svg" alt="MongoDB" />
                              <p className="tech-title">MongoDB</p>
                            </li>
                            <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                              <img className="tech-icon" src="services/technologies/Firebase.svg" alt="Firebase" />
                              <p className="tech-title">Firebase</p>
                            </li>
                          </ul>
                        </div>


                        <div className="mt--50">
                          <Link to="/web-development" target="blank" className="btn btn-sm view-projects-btn btn-outline-primary">Know More</Link>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>


          {/* Digital Marketing */}
          <section style={{ minHeight: "28rem" }} className="siteSection with-bg b-spaced lab-product spectrum-item bg-pattern-spectrum">
            <div className="bgGradient spectrum-green-lab radial-tl gradient-sec"></div>
            <div className="siteSection--header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <Link to="digital-marketing" className="link-hover">
                      <h2 data-sal="slide-up"className="header-title text-success">Digital Marketing</h2></Link>
                    <p data-sal="slide-up"className="header-description">At BizDamn, we believe that merely building great products is not enough. Getting them out in the open and hooking people on to them is the secret growth mantra.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="siteSection--body">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <img src="" className="artwork" />
                    <div className="serviceTechHolder">
                      <div className="serviceTechHolder-header">
                        <div className="title-holder">
                          {/* <h4 className="title">Technologies</h4> */}
                        </div>
                      </div>

                      <div className="mt--50">
                        <Link to="/digital-marketing" target="blank" className="btn btn-sm view-projects-btn btn-outline-success">Know More</Link>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Designing */}
          <section id='design' style={{ minHeight: "40rem" }} className="siteSection with-bg b-spaced lab-product vectors-item">
            <div className="bgGradient vectors-orange radial-tl gradient-sec"></div>
            <div className="siteSection--header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <Link style={{ color: "#FFBD37" }} to="/designing" className="link-hover">
                      <h2 data-sal="slide-up"className="header-title">Web Designing (UI/UX Design)</h2></Link>
                    {/* <p className="header-description">In today’s customer-centric world, user experience is everything. At BizDamn, we have a seasoned team of UI/UX designers with an innovative mindset.</p> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="siteSection--body">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <img src="" className="artwork" />


                    <div className="serviceTechHolder">
                      <div className="serviceTechHolder-header">
                        <div className="title-holder">
                          {/* <h4 className="title">Design</h4> */}
                        </div>
                      </div>

                      <div className="serviceTechHolder-body">
                        <ul className="tech-list">


                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/Illustrator.svg" alt="Illustrator" />
                            <p className="tech-title">Illustrator</p>
                          </li>
                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/Photoshop.svg" alt="Photoshop" />
                            <p className="tech-title">Photoshop</p>
                          </li>
                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/CorelDraw.svg" alt="Corel Draw" />
                            <p className="tech-title">Corel Draw</p>
                          </li>

                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/Framer.svg" alt="Framer" />
                            <p className="tech-title">Framer</p>
                          </li>
                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/AdobeXD.svg" alt="Adobe XD" />
                            <p className="tech-title">Adobe XD</p>
                          </li>
                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/Marvel.svg" alt="Marvel" />
                            <p className="tech-title">Marvel</p>
                          </li>
                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/Sketch.svg" alt="Sketch" />
                            <p className="tech-title">Sketch</p>
                          </li>

                        </ul>
                      </div>


                    </div>
                  
                    


                    <div className="serviceTechHolder">
                      <div className="serviceTechHolder-header">
                        <div className="title-holder">
                          <h4 data-sal="slide-up"className="title">Animation</h4>
                        </div>
                      </div>

                      <div className="serviceTechHolder-body">
                        <ul className="tech-list">

                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/AfterEffects.svg" alt="After Effects" />
                            <p className="tech-title">After Effects</p>
                          </li>
                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/Lottie.png" alt="Lottie" />
                            <p className="tech-title">Lottie</p>
                          </li>

                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/PremierePro.svg" alt="Premiere Pro" />
                            <p className="tech-title">Premiere Pro</p>
                          </li>
                          <li  data-sal="slide-right"  data-sal-easing="ease" className="list-item">
                            <img className="tech-icon" src="services/technologies/Blender.svg" alt="Blender" />
                            <p className="tech-title">Blender</p>
                          </li>

                        </ul>
                      </div>



                      <div className="mt--50">
                        <Link to="/designing" target="blank" className="btn btn-sm btn-outline-vectors">Know More</Link>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>




          {/* Projects and Contact Us */}
          <section className="footerCTASection with-bg blue">
            <div className="container">
              <div className="artwork" style={{ backgroundImage: `url(${"./illustrations/footer-cta-illustration.svg"})` }} ></div>
              <div className="row footerCTASection--holder">
                <div className="col-md-8 holder-item">
                  <div className="holder-item-wrapper row justify-content-center">
                    <div className="col-md-10 col-lg-8">
                      <h3 data-sal="slide-up"className="sec-title text-primary">
                        NEW PROJECT ON THE HORIZON?

                      </h3>
                      <p data-sal="slide-up"className="sec-info text-secondary hide-section">Partner with a Reliable Agency</p>
                      <Link data-sal="slide-right"to="/website-packages" type="button"
                        className="btn btn-sm btn-outline-primary btn-width mt--20">
                        Get Started
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 holder-item">
                  {/* Something */}
                </div>
              </div>
            </div>
          </section>
        </main>

      </div>
    </>
  );
  export default Technologies;